module.exports = __webpack_public_path__ + "static/media/jupiter.de37a950.svg";